import { Component, Listen, Prop, State, h } from '@stencil/core';
import { ConversationalSearchMessagesInitialQuestion } from '../../predefined/initial-question/initial-question';
import type {labelProviderInterface} from '../../../../../LabelProviderInterface';
import dynamicBannerStore from '../../../conversational-search-banners/dynamic-banner/dynamic-banner-store';

@Component({
  tag: 'uiaas-search-widget-conversational-search-messages-preload-mediator',
  shadow: false,
})
export class ConversationalSearchMessagesPreloadMediator {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly searchQuery: string;
  @Prop() readonly preloadCallback: (chatQuery) => void;
  @Prop() readonly country: string;
  @Prop() readonly language: string;
  @Prop() readonly conversationalSearchMedaliaFormId: string;
  @Prop() readonly conversationalSearchBrandUrl: string;

  @State() isTermsAccepted = false;
  @State() isNewConversation = false;
  @State() chatQuery: string;


  @Listen('conversational-search:user-start-of-conversation', {
    target: 'window',
  })
  userQuestionStatetHandler() {
      this.isTermsAccepted = true;
      this.preloadCallback(this.chatQuery);
  }

  @Listen('conversational-search:user-new-conversation', {
    target: 'window',
  })
  userNewConversationHandler() {
      this.isNewConversation = true;
  }

  @Listen('conversational-search:input-action', { target: 'window' })
  handleNewchatQueryFromBanner(e) {
      this.chatQuery = e.detail.query;
  }

  private newConversationTemplate = () => (
    <uiaas-conversational-search-message-new-conversation
      labelProvider={(e, f) => this.labelProvider(e, f)}
      query={this.searchQuery}
    />
  );

  private preloadedMessageTemplate = () => {
      const preloadData = dynamicBannerStore.get('data');

      return (
        <uiaas-search-widget-conversational-search-messages-dynamic-mediator
          data={preloadData}
          labelProvider={(e, f) => this.labelProvider(e, f)}
          query={this.searchQuery}
          country={this.country}
          language={this.language}
          conversationalSearchMedaliaFormId={this.conversationalSearchMedaliaFormId}
          conversationalSearchBrandUrl={this.conversationalSearchBrandUrl}
        />
      );
  };

  render() {
      if (!this.isNewConversation)
        return (
          <section>
            {this.preloadedMessageTemplate()}
          </section>
        );

      if (!this.isNewConversation) return this.preloadedMessageTemplate();
      if (this.isNewConversation) return this.newConversationTemplate();
  }
}
